<div class="signup-container">
  <div class="signup-card">
    <div class="signup-header">
      <h1>Create Account</h1>
      <p>Join CanvasBloom Platform</p>
    </div>

    @if (errorMessage) {
      <div class="alert-message error-message">
        {{ errorMessage }}
      </div>
    }

    @if (successMessage) {
      <div class="alert-message success-message">
        {{ successMessage }}
      </div>
    }

    <form [formGroup]="signupForm" (ngSubmit)="onSubmit()" class="signup-form">
      <div class="form-row">
        <div class="form-group">
          <label for="firstName">First Name *</label>
          <input
            type="text"
            id="firstName"
            formControlName="firstName"
            placeholder="First name"
            [class.error]="firstName?.invalid && firstName?.touched"
            />
          @if (firstName?.invalid && firstName?.touched) {
            <div class="error-message">
              @if (firstName?.errors?.['required']) {
                <span>First name is required</span>
              }
            </div>
          }
        </div>

        <div class="form-group">
          <label for="lastName">Last Name</label>
          <input
            type="text"
            id="lastName"
            formControlName="lastName"
            placeholder="Last name"
            />
        </div>
      </div>

      <div class="form-group">
        <label for="email">Email *</label>
        <input
          type="email"
          id="email"
          formControlName="email"
          placeholder="Enter your email"
          [class.error]="email?.invalid && email?.touched"
          />
        @if (email?.invalid && email?.touched) {
          <div class="error-message">
            @if (email?.errors?.['required']) {
              <span>Email is required</span>
            }
            @if (email?.errors?.['email']) {
              <span>Invalid email format</span>
            }
          </div>
        }
      </div>

      <div class="form-group">
        <label for="phone">Phone</label>
        <input
          type="tel"
          id="phone"
          formControlName="phone"
          placeholder="Phone number (optional)"
          />
      </div>

      <div class="form-group">
        <label for="password">Password *</label>
        <input
          type="password"
          id="password"
          formControlName="password"
          placeholder="Create a password"
          [class.error]="password?.invalid && password?.touched"
          />
        <div class="password-hint">
          Password must be at least 8 characters with uppercase, lowercase, number, and special character
        </div>
        @if (password?.invalid && password?.touched) {
          <div class="error-message">
            @if (password?.errors?.['required']) {
              <span>Password is required</span>
            }
            @if (password?.errors?.['minlength']) {
              <span>Password must be at least 8 characters</span>
            }
            @if (password?.errors?.['pattern']) {
              <span>Password must contain uppercase, lowercase, number, and special character</span>
            }
          </div>
        }
      </div>

      <button
        type="submit"
        class="btn-primary"
        [disabled]="signupForm.invalid || loading"
        >
        {{ loading ? 'Creating Account...' : 'Sign Up' }}
      </button>

      <div class="divider">
        <span>OR</span>
      </div>

      <div id="googleSignUpButton" class="google-button-container"></div>

      <div class="login-link">
        Already have an account? <a routerLink="/login">Login</a>
      </div>
    </form>
  </div>
</div>
